var _defs, _mask;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlanWhite(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    id: "svg2127",
    width: 682.66669,
    height: 682.66669,
    viewBox: "0 0 682.66669 682.66669",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs2131"
  }, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath2141"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,512 H 512 V 0 H 0 Z",
    id: "path2139"
  })))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "custom"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "bg",
    x: 0,
    y: 0,
    width: "100%",
    height: "100%",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.3333333,0,0,-1.3333333,0,682.66667)"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#custom)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2133",
    transform: "matrix(1.3333333,0,0,-1.3333333,0,682.66667)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2135"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2137",
    clipPath: "url(#clipPath2141)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2143",
    transform: "translate(195,492)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 h 257 c 22.091,0 40,-17.908 40,-40 v -210 c 0,-22.092 -17.909,-40 -40,-40 h -34",
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 40,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path2145"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2147",
    transform: "translate(96,20)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 h -36 c -22.091,0 -40,17.908 -40,40 v 392 c 0,22.092 17.909,40 40,40 h 35",
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 40,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path2149"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2151",
    transform: "translate(270,280)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 v -220 c 0,-22.092 -17.909,-40 -40,-40 h -33",
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 40,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path2153"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2155",
    transform: "translate(347,202)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H -79",
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 40,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path2157"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2159",
    transform: "translate(270,350)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 V 142",
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 40,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path2161"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2163",
    transform: "translate(180,239)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H -151",
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 40,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path2165"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2167",
    transform: "translate(160.9995,280)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 V -80",
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 40,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path2169"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2171",
    transform: "translate(310,369)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H -80",
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 40,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path2173"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2175",
    transform: "translate(399,329)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 V 80",
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 40,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path2177"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2179",
    transform: "translate(500,369)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H -120",
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 40,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path2181"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanWhite);
export default __webpack_public_path__ + "static/media/planWhite.3d7929f2f31b64e01d211ffc107aba3b.svg";
export { ForwardRef as ReactComponent };